"use client";

import React, { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { chevronDown, closeIcon, hamburgerIcon } from "../../assets";
import styles from "./header.module.css";

const Header = ({ brand, linkStyles, mobileBrand, brandToggle }) => {
  const [showMenu, setShowMenu] = useState(false);
  const router = useRouter();

  const handleNav = (link) => {
    if (link && typeof link === "string") {
      router.push(link);
    }
  };

  const navItems = [
    {
      name: "Use cases",
      icon: chevronDown,
      hoveredItems: [
        {
          name: "Estate",
          link: "/estate",
        },
        {
          name: "Fitness",
          link: "/fitness",
        },
        {
          name: "Product",
          link: "/product",
        },
      ],
    },
    {
      name: "Events",
      link: "/events",
    },
    {
      name: "Pricing",
      link: "/pricing",
    },
  ];

  const menuHandler = () => {
    setShowMenu(!showMenu);
  };

  const hideMenu = () => {
    setShowMenu(false);
  };

  return (
    <header
      className={showMenu ? `${styles.mobileheader} ` : `${styles.header} `}
    >
      <Link href="/">
        <div className={styles.brandImagecontainer}>
          <Image
            src={showMenu ? brandToggle : brand}
            alt="circleplug brand logo"
            className={`${styles.brandlogo} ${styles.desktopLogo}`}
          />
          <Image
            src={showMenu ? brandToggle : mobileBrand}
            alt="circleplug brand logo"
            className={`${styles.brandlogo} ${styles.mobileLogo}`}
          />
        </div>
      </Link>
      <nav
        className={
          showMenu ? styles.showNav : `${styles.hideMenu} ${styles.nav}`
        }
      >
        <div className={styles.navItems}>
          <div className={styles.leftlinks}></div>
          <div className={styles.headerright}>
            {navItems.map(({ name, icon, link, hoveredItems }) => {
              if (icon) {
                return (
                  <div
                    key={name}
                    onClick={() => {
                      if (!hoveredItems) handleNav(link);
                    }}
                    className={`${styles.link} ${styles.linkwithIcon} ${linkStyles}`}
                  >
                    <div className={styles.linkwithIconwrapper}>
                      <p>{name}</p>
                      <span>{icon}</span>
                    </div>

                    {hoveredItems && (
                      <div className={styles.subMenu}>
                        {hoveredItems.map((subItem, subIndex) => (
                          <div
                            key={subIndex}
                            onClick={() => handleNav(subItem.link)}
                            className={styles.subMenuItem}
                          >
                            <li>{subItem.name}</li>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <div
                  key={name}
                  onClick={() => handleNav(link)}
                  className={`${linkStyles ? styles.linkStyles : styles.link}`}
                >
                  {name}
                </div>
              );
            })}
          </div>
        </div>
      </nav>
      <div className={styles.hamburger}>
        {showMenu ? (
          <span onClick={hideMenu}>{closeIcon}</span>
        ) : (
          <span onClick={menuHandler}>{hamburgerIcon}</span>
        )}
      </div>
    </header>
  );
};

export default Header;
